import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBarsTwo2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bars-two-2, menu, nav"><path fillRule="evenodd" clipRule="evenodd" d="M2 7.25C2 6.83579 2.33579 6.5 2.75 6.5H21.25C21.6642 6.5 22 6.83579 22 7.25C22 7.66421 21.6642 8 21.25 8H2.75C2.33579 8 2 7.66421 2 7.25ZM2 16.75C2 16.3358 2.33579 16 2.75 16H14.25C14.6642 16 15 16.3358 15 16.75C15 17.1642 14.6642 17.5 14.25 17.5H2.75C2.33579 17.5 2 17.1642 2 16.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBarsTwo2;
